__turbopack_context__.v({
  "container": "ay-I4q_container",
  "slim": "ay-I4q_slim",
});
